export enum WindowOpenTarget {
  Top = '_top',
  Self = '_self',
  Parent = '_parent',
  Blank = '_blank'
}
